var _path, _path2;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImgDiscountRosette(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.845 4.432a3.831 3.831 0 0 0-.063 1.904 3.831 3.831 0 0 0 0 6.475 3.831 3.831 0 0 0 4.579 4.568 3.83 3.83 0 0 0 6.465 0 3.832 3.832 0 0 0 4.568-4.578 3.83 3.83 0 0 0 0-6.455 3.831 3.831 0 0 0-4.578-4.579 3.83 3.83 0 0 0-6.455 0 3.831 3.831 0 0 0-4.516 2.665ZM12.699 6.47l-6.207 6.207Zm-6.207 0h.01Zm6.207 6.207h.01Z",
    fill: "#27AE60"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m12.699 6.47-6.207 6.207m0-6.207h.01m6.197 6.207h.01",
    stroke: "#fff",
    strokeWidth: 2.394,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgDiscountRosette);
export default __webpack_public_path__ + "static/media/img_discount_rosette.1a524a3d2ee273f303d7f1cb5bc68295.svg";
export { ForwardRef as ReactComponent };